import { TrackingManager } from '@benzinga/tracking-manager';
import { getSessionSingleton } from '@benzinga/session';

const slugifyNavSegment = (value: string): string => {
  const slug = value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
  return slug || 'item';
};

export const handleMenuItemsClickEvent = (buttonLocation: string, linkType: string, buttonLabel?: string): void => {
  const session = getSessionSingleton();
  const placement = slugifyNavSegment(linkType);
  const itemSlug = slugifyNavSegment(buttonLabel ?? '');
  session.getManager(TrackingManager).trackLinkEvent('click', {
    button_id: `nav_${placement}_${itemSlug}`,
    button_label: buttonLabel,
    button_location: buttonLocation,
    button_type: 'navigation',
    link_type: linkType,
  });
};
